const SIGNIN_KEY = 'delayed-signin-event';

export const setDelayedSignInEventState = (state: boolean) => {
  if (!state) localStorage.removeItem(SIGNIN_KEY);
  else localStorage.setItem(SIGNIN_KEY, '1');
};

export const isDelayedSignInEventState = () => localStorage.getItem(SIGNIN_KEY) === '1';
